import * as React from "react";
import IconBase from "./IconBase";

function IconFullscreenExit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path
        fill="currentColor"
        d="M8.2 4.2c.7 0 1.2.5 1.2 1.2v3.2h3.2c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2H8.1c-.6 0-1.1-.5-1.1-1.1V5.4c0-.7.5-1.2 1.2-1.2m7.6 0c.7 0 1.2.5 1.2 1.2v4.5c0 .6-.5 1.1-1.1 1.1h-4.5c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2h3.2V5.4c0-.7.5-1.2 1.2-1.2M7 14.1c0-.6.5-1.1 1.1-1.1h4.5c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2H9.4v3.2c0 .7-.5 1.2-1.2 1.2S7 19.3 7 18.6zm4.4-1.1h4.5c.6 0 1.1.5 1.1 1.1v4.5c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2v-3.2h-3.2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2"
      />
    </IconBase>
  );
}

export default IconFullscreenExit;
